var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column align-items-center justify-content-center min-vh-100"
    },
    [
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _vm._v("Processing, please wait")
            ])
          ])
        : _vm.error
        ? _c("div", { staticClass: "text-center" }, [
            _vm._v("Error: " + _vm._s(_vm.error))
          ])
        : _c("div", { staticClass: "text-center" }, [
            _vm._v("Please continue on the BeNeat app")
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2c66be2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2c66be2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airbnb/AirbnbLoginCallback.vue
// module id = 2501
// module chunks = 0